class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    const alreadyOpen = this.classList.contains('active');

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      
      // Extend - Disptch event to refresh Extend
      window.dispatchEvent(new Event('refreshAjaxSideCart'));
      // Extend - End Extend code

      this.classList.add('animate', 'active');
    });

    // If drawer is already open, transitionend won't fire; announce immediately
    if (alreadyOpen && this.pendingOpenAnnouncement) {
      const msg = this.pendingOpenAnnouncement;
      this.pendingOpenAnnouncement = null;
      setTimeout(() => {
        if (typeof window.announceCartStatus === 'function') {
          window.announceCartStatus(msg);
        }
      }, 100);
    }

    this.addEventListener(
      'transitionend',
      () => {
        const drawerContainer = document.getElementById('CartDrawer');
        const emptyContainer = this.querySelector('.drawer__inner-empty');
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? emptyContainer || drawerContainer
          : drawerContainer;
        if (!containerToTrapFocusOn) return;
        const focusElement =
          containerToTrapFocusOn.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close') ||
          containerToTrapFocusOn;
        trapFocus(containerToTrapFocusOn, focusElement);

        // Announce add-to-cart success after focus is stable in the drawer
        if (this.pendingOpenAnnouncement && typeof window.announceCartStatus === 'function') {
          window.announceCartStatus(this.pendingOpenAnnouncement);
          this.pendingOpenAnnouncement = null;
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Store announcement message; it will be read after the drawer opens and focus is trapped
    if (typeof window.getCartAddedMessage === 'function') {
      this.pendingOpenAnnouncement = window.getCartAddedMessage(parsedState);
    } else if (window.cartStrings?.itemAdded) {
      this.pendingOpenAnnouncement = window.cartStrings.itemAdded;
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer-LiveRegionText',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
